export const DATA_HEADERS_REQUEST = 'DATA_HEADERS_REQUEST'
export const DATA_HEADERS = 'DATA_HEADERS'